<template>
  <v-row class="fill-height">
    <v-col style="padding:0">
      <v-sheet height="64">
        <v-toolbar flat color="white">
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-menu bottom right>
            <template v-slot:activator="{ on }">
              <v-btn outlined color="grey darken-2" v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Day</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Week</v-list-item-title>
              </v-list-item>
              <!-- <v-list-item @click="type = 'month'">
                        <v-list-item-title>Month</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = '4day'">
                        <v-list-item-title>4 days</v-list-item-title>
              </v-list-item>-->
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="64">
        <v-toolbar flat color="white">
          <v-row justify="space-around">
            <v-btn fab small color="primary" @click="prev">
              <v-icon dark small>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn outlined class="mr-4" color="primary" @click="setToday"
              >Today</v-btn
            >
            <v-btn fab small color="primary" @click="next">
              <v-icon small>mdi-chevron-right</v-icon>
            </v-btn>
          </v-row>
        </v-toolbar>
      </v-sheet>

      <v-sheet height="auto">
        <v-row justify="center">
          <!-- <v-btn fab color="primary" bottom right fixed dark v-on="on">
                <v-icon>mdi-plus</v-icon>
          </v-btn>-->
          <v-speed-dial
            v-model="speed_dial"
            fixed
            bottom
            right
            direction="top"
            transition="slide-y-reverse-transition"
          >
            <template v-slot:activator>
              <v-btn
                v-model="speed_dial"
                color="primary"
                dark
                fab
                :small="$vuetify.breakpoint.smAndDown"
              >
                <v-icon v-if="speed_dial">mdi-close</v-icon>
                <v-icon v-else>mdi-plus</v-icon>
              </v-btn>
            </template>

            <v-btn fab dark small color="primary" @click="showClientDialog">
              <span style="position:absolute; left:-90px ; color:#000"
                >add client</span
              >
              <v-icon>mdi-account-plus</v-icon>
            </v-btn>
            <v-btn fab dark small color="primary" @click="OpenEmptyAppointment">
              <span style="position:absolute; left:-140px ; color:#000"
                >add appointment</span
              >
              <v-icon>mdi-calendar-plus</v-icon>
            </v-btn>
            <v-btn fab dark small color="primary" @click="OpenEmptyTaskDialog">
              <span style="position:absolute; left:-80px ; color:#000"
                >add task</span
              >
              <v-icon>mdi-bell-ring</v-icon>
            </v-btn>
          </v-speed-dial>
        </v-row>

        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          :event-color="getEventColor"
          :type="type"
          :interval-format="format"
          :weekdays="[1, 2, 3, 4, 5, 6, 0]"
          :first-interval="this.$store.getters.startingHour"
          interval-count="18"
          interval-width="48"
          :interval-style="intervalStyle"
          :short-intervals="false"
          :short-weekdays="true"
          event-overlap-mode="stack"
          :event-overlap-threshold="30"
          @click:time="addAt"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
          @change="updateRange"
        >
          <template #day-body="{ date, week }">
            <div
              v-if="date == $moment().format('YYYY-MM-DD')"
              class="v-current-time"
              :class="{ first: date === week[0].date }"
              :style="{ top: nowY }"
            ></div>
          </template>
          <template v-slot:event="{ event }">
            <v-icon v-if="event.type == 'task'" small dark
              >mdi-bell-ring</v-icon
            >
            <strong class="pl-1">{{ event.name }}</strong>
          </template>

          <!-- <template v-slot:day-label-header="{ day, time }">
            
          </template>-->
        </v-calendar>

        <!-- Edit appointment dialog -->
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
          v-if="selectedElement"
          max-width="350px"
        >
          <v-card color="grey lighten-4" min-width="260px" flat>
            <v-toolbar :color="selectedEvent.color" dark>
              <v-btn icon fab @click="showDialog(selectedEvent.type)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
            </v-toolbar>
            <v-card-text v-if="selectedEvent.type == 'appointment'">
              <v-row>
                <v-col cols="12">
                  <!-- <span v-html="selectedEvent.start"></span> -->
                  <span
                    v-html="$moment(selectedEvent.start).format('HH:mm')"
                  ></span>
                  -
                  <span
                    v-html="$moment(selectedEvent.end).format('HH:mm')"
                  ></span>
                </v-col>
              </v-row>

              <v-chip
                text
                v-for="service in selectedEvent.services"
                :key="service.id"
                >{{ service.serviceName }}</v-chip
              >
            </v-card-text>
            <v-card-text v-else>
              <span v-html="selectedEvent.description"></span>
            </v-card-text>
            <v-card-actions>
              <v-btn text color="secondary" @click="selectedOpen = false"
                >Cancel</v-btn
              >
              <v-spacer></v-spacer>

              <v-dialog
                v-model="deleteDialogisVisible"
                justify-center
                max-width="290"
              >
                <template v-slot:activator="{ on }">
                  <v-btn icon fab light color="red" v-on="on">
                    <v-icon dark>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <v-card color="grey lighten-4">
                  <v-toolbar dark color="red">
                    <v-card-title
                      >Delete {{ this.selectedEvent.name }}</v-card-title
                    >
                  </v-toolbar>

                  <v-card-actions justify-space-around>
                    <v-btn
                      dark
                      color="grey"
                      @click="deleteDialogisVisible = false"
                      >Cancel</v-btn
                    >
                    <v-btn dark color="error" @click="DeleteAppointment()"
                      >Delete</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-actions>
          </v-card>
        </v-menu>
        <!-- END Edit appointment dialog -->
      </v-sheet>
    </v-col>
    <appointmentDialog
      :event="selectedEvent"
      @close="closeDialog"
      ref="appointmentDialog"
    ></appointmentDialog>
    <task-dialog
      :event="selectedEvent"
      @close="closeDialog"
      ref="taskDialog"
    ></task-dialog>
    <addClientDialog ref="clientDialog"></addClientDialog>
  </v-row>
</template>

<script>
const stylings = {
  past(interval) {
    return {
      backgroundColor: interval.past ? 'rgba(0,0,0,0.05)' : undefined,
    };
  },
};
import axios from 'axios';
import moment from 'moment';
import addClientDialog from '../dialogs/AddClientDialog';
import AppointmentDialog from '../dialogs/AppointmentDialog';
import TaskDialog from '../dialogs/TaskDialog';
export default {
  name: 'Calendar',
  components: {
    addClientDialog,
    AppointmentDialog,
    TaskDialog,
  },
  data: () => ({
    // event: [],
    styleInterval: 'past',
    ready: false,
    speed_dial: null,
    deleteDialogisVisible: false,
    focus: '',
    apponintment: null,
    type: 'week',
    typeToLabel: {
      month: 'Month',
      week: 'Week',
      day: 'Day',
      '4day': '4 Days',
    },
    //today: moment().format("YYYY-MM-DD"),
    start: null,
    end: null,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    openEventDialog: false,
    dialog: false,
    events: [],
    colors: [
      // "blue",
      // "indigo",
      // "deep-purple",
      // "cyan",
      // "green",
      // "orange",
      // "grey darken-1",

      '#F44336',
      '#E91E63',
      '#9C27B0',
      '#673AB7',
      '#3F51B5',
      '#2196F3',
      '#1976d2',
      '#03A9F4',
      '#00BCD4',
      '#009688',
      '#4CAF50',
      '#8BC34A',
      '#CDDC39',
      //'#FFEB3B',  citromsarga
      '#FFC107',
      '#FF9800',
      '#FF5722',
      '#795548',
      '#607D8B',
      '#9E9E9E',
      '#000000',
    ],
    names: [
      'Meeting',
      'Holiday',
      'PTO',
      'Travel',
      'Event',
      'Birthday',
      'Conference',
      'Party',
    ],
  }),
  computed: {
    seletedUserId() {
      return this.$store.getters.SelectedUser.id ?? '';
    },

    title() {
      const { start, end } = this;
      if (!start || !end) {
        return '';
      }

      const startMonth = this.monthFormatter(start);
      const endMonth = this.monthFormatter(end);
      const suffixMonth = startMonth === endMonth ? '' : endMonth;

      const startYear = start.year;
      //const endYear = end.year;
      //const suffixYear = startYear === endYear ? "" : endYear;

      const startDay = start.day + this.nth(start.day);
      const endDay = end.day + this.nth(end.day);

      switch (this.type) {
        case 'month':
          return `${startMonth} ${startYear}`;
        case 'week':
        case '4day':
          // return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`;
          return `${startMonth} ${startDay}  - ${suffixMonth} ${endDay}`;
        case 'day':
          return `${startMonth} ${startDay} ${startYear}`;
      }
      return '';
    },
    monthFormatter() {
      return this.cal.getFormatter({
        timeZone: 'UTC',
        month: 'long',
      });
    },
    cal() {
      return this.ready ? this.$refs.calendar : null;
    },
    nowY() {
      return this.cal ? this.cal.timeToY(this.cal.times.now) + 'px' : '-10px';
    },
    intervalStyle() {
      return stylings['past'].bind(this);
    },
  },
  created() {
    // if (this.$store.getters.SelectedUser) {
    //   this.getEvents();
    // }
  },

  mounted() {
    this.ready = true;
    this.scrollToTime();
    this.updateTime();

    this.cal.checkChange();
    //setTimeout(() => {
    //this.getEvents();
    //}, 1000);
  },
  methods: {
    DeleteAppointment() {
      let index = this.events.indexOf(this.selectedEvent);
      this.events.splice(index, 1);
      this.deleteDialogisVisible = false;

      let appointmentID = {
        id: this.selectedEvent.id,
      };

      let mutation = `mutation deleteAppointment($id: String!) {
            deleteAppointment(appointmentID: $id) {
              id
            }
          }`;

      axios
        .post('/graphql', {
          query: mutation,
          variables: appointmentID,
        })
        .then((res) => {
          if (res.data.data.deleteAppointment.id) {
            this.selectedEvent = {};
            this.selectedOpen = false;
            this.cal.checkChange();
            this.showSuccess('Appointment deleted!');
          }
        })
        .catch(() =>
          this.showError('Error occured while deleting appointment!')
        );
    },
    OpenEmptyAppointment() {
      this.selectedEvent = {};
      this.showDialog('appointment');
    },
    OpenEmptyTaskDialog() {
      this.selectedEvent = {};
      this.showDialog('task');
    },
    showDialog(type) {
      if (type == 'appointment') {
        this.$refs.appointmentDialog.isVisible = true;
      } else {
        this.$refs.taskDialog.isVisible = true;
      }
    },
    showClientDialog() {
      this.$refs.clientDialog.isVisible = true;
    },
    Update() {
      this.getEvents();
    },
    getEvents() {
      let queryString = `query currentuserweeklyappointments($id: String!, $datefrom: DateTime!, $dateto: DateTime!){
        currentuserweeklyappointments(id:$id,datefrom:$datefrom, dateto:$dateto){
                              id,
                              name,
                              type,
                              startTimeStamp,
                              endTimeStamp,
                              appointmentService{
                                service{
                                  id
                                  serviceName
                                  duration
                                  price
                                }
                              },
                              client{
                                id
                                name
                                description
                                phoneNumber
                              },
                              description
                          }
                        }`;

      axios
        .post('/graphql', {
          query: queryString,
          variables: {
            id: this.$store.getters.SelectedUser.id, // TODO IMPORTANT : Get logged in users ID
            datefrom: this.start.date,
            dateto: this.end.date,
          },
        })
        .then((response) => {
          return this.ConvertToEvent(
            response.data.data.currentuserweeklyappointments
          );
        })
        .then((events) => {
          this.events = [];

          events.forEach((ev) => {
            this.events.push(ev);
          });
          this.cal.checkChange();
        })
        .catch(() => {
          this.showError('Could not get events');
        });
    },
    ConvertToEvent(appointments) {
      let events = [];
      appointments.forEach((element) => {
        events.push({
          name:
            element.type == 'appointment' ? element.client.name : element.name,
          date: moment(element.startTimeStamp).format('YYYY-MM-DD'),
          startTime: moment(element.startTimeStamp).format('HH:mm'),
          endTime: moment(element.endTimeStamp).format('HH:mm'),
          start: moment(element.startTimeStamp).format('YYYY-MM-DD HH:mm'),
          end: moment(element.endTimeStamp).format('YYYY-MM-DD HH:mm'),
          color:
            element.type == 'task'
              ? 'red lighten-2'
              : this.colors[this.rnd(0, this.colors.length - 1)],
          id: element.id,
          client: element.client,
          type: element.type,
          description: element.description,
          services: this.CreateServiceList(element.appointmentService),
        });
      });
      return events;
    },
    CreateServiceList(appointmentServices) {
      let services = [];
      appointmentServices.forEach((service) => {
        services.push(service.service);
      });
      return services;
    },

    getCurrentTime() {
      return this.cal
        ? this.cal.times.now.hour * 60 + this.cal.times.now.minute
        : 0;
    },
    scrollToTime() {
      const time = this.getCurrentTime();
      const first = Math.max(0, time - (time % 30) - 30);

      this.cal.scrollToTime(first);
    },
    updateTime() {
      setInterval(() => this.cal.updateTimes(), 60 * 1000);
    },
    roundTime(time, down = true) {
      const roundTo = 15; // minutes
      const roundDownTime = roundTo * 60 * 1000;

      return down
        ? time - (time % roundDownTime)
        : time + (roundDownTime - (time % roundDownTime));
    },
    toTime(tms) {
      return new Date(
        tms.year,
        tms.month - 1,
        tms.day,
        tms.hour,
        tms.minute
      ).getTime();
    },
    addAt(ev) {
      if (ev.past) {
        return;
      }
      const time = this.toTime(ev);
      let createStart = this.roundTime(time);
      let startTime = moment(createStart); //.toISOString(true);
      this.selectedEvent = {
        date: moment(createStart).format('YYYY-MM-DD'),
        start: startTime.format('YYYY-MM-DD HH:mm'),
        startTime: startTime.format('HH:mm'),
      };

      this.showDialog('appointment');

      // const time = this.toTime(ev);
      // let createStart = this.roundTime(time);
      //let startTime = moment(createStart).toISOString(true);
    },
    format(interval) {
      return interval.time;
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = 'day';
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = this.today;
    },
    prev() {
      this.cal.prev();
    },
    next() {
      this.cal.next();
    },

    closeDialog() {
      //this.selectedEvent = {};
      this.selectedOpen = false;
      this.Update();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      // const events = [];

      // const min = new Date(`${start.date}T00:00:00`);
      // const max = new Date(`${end.date}T23:59:59`);
      // const days = (max.getTime() - min.getTime()) / 86400000;
      // const eventCount = this.rnd(days, days + 20);

      // for (let i = 0; i < eventCount; i++) {
      //   const allDay = this.rnd(0, 3) === 0;
      //   const firstTimestamp = this.rnd(min.getTime(), max.getTime());
      //   const first = new Date(firstTimestamp - (firstTimestamp % 900000));
      //   const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000;
      //   const second = new Date(first.getTime() + secondTimestamp);

      //   events.push({
      //     name: this.names[this.rnd(0, this.names.length - 1)],
      //     start: this.formatDate(first, !allDay),
      //     end: this.formatDate(second, !allDay),
      //     color: this.colors[this.rnd(0, this.colors.length - 1)]
      //   });
      // }

      this.start = start;
      this.end = end;
      this.getEvents();
    },
    nth(d) {
      return d > 3 && d < 21
        ? 'th'
        : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10];
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    formatDate(a, withTime) {
      return withTime
        ? `${a.getFullYear()}-${a.getMonth() +
            1}-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
        : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`;
    },
  },
};
</script>
<style scoped lang="scss">
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
  left: 4px;
  margin-right: 8px;
  position: relative;
}

.my-event.with-time {
  position: absolute;
  right: 4px;
  margin-right: 0px;
}
.v-current-time {
  height: 2px;
  //background-color: #ea4335;
  background-color: black;
  position: absolute;
  left: -1px;
  right: 0;
  pointer-events: none;

  &.first::before {
    content: '';
    position: absolute;
    // background-color: #ea4335;
    background-color: black;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-top: -5px;
    margin-left: -6.5px;
  }
}
</style>
